import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    position: 'relative',

    '& input:focus + label': {
      color: cssVariables.colorBlue,
    },
  },
  label: {
    display: 'inline-block',
    margin: '0 1rem 0 0',
  },
  displayLabel: {
    fontSize: '1rem',
    fontWeight: 'bold',
    margin: '0 0 .7rem',
    transition: `${cssVariables.paceFast} ${cssVariables.easeIn} color`,
  },
  input: {
    clip: 'rect(1px, 1px, 1px, 1px)',
    position: 'absolute !important',
    height: '1px',
    width: '1px',
    overflow: 'hidden',
    margin: '-1px',
    padding: '0',
    border: '0',
  },
  buttonWrapper: {
    display: 'inline-block',
    transform: 'translateY(-4px)',
  },

  upload: {
    minWidth: '14rem',
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${cssVariables.colorGrayC}`,
    padding: '.5rem 1rem',
    borderRadius: '5px',

    '&:hover': {
      color: cssVariables.colorBlue,
    },
  },
  uploadIcon: {
    padding: '0 .5rem 0 0',
  },
  disabled: {
    '&:hover': {
      color: `${cssVariables.colorGrayC} !important`,
    },
  },
}
